import React from 'react'

import { NonCompliantLabel } from './NonCompliantLabel'
import { Icon } from '../../atoms'
import { NonCompliantRulesFragment } from '../../../lib/graphql'

const NonCompliantMessage = ({
  clientProposal,
}: {
  clientProposal: NonCompliantRulesFragment
}) => (
  <div className='flex items-center gap-2 rounded-md bg-grey-300 p-2 text-xs text-grey-800'>
    <Icon size={36} name='info-outline' />
    <NonCompliantLabel clientProposal={clientProposal} />
  </div>
)

export default NonCompliantMessage
